var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"message-fade"}},[(_vm.visible)?_c('div',{staticClass:"message",class:_vm.type},[_c('div',{staticClass:"message-content"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }